import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t bg-white">
      <div className="max-w-6xl mx-auto px-6 py-10">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="text-2xl font-extrabold">TytyStyle</div>
            <p className="mt-2 text-sm text-gray-600">
              Atelier de rochii pe comandă — eleganță, croi personalizat și materiale premium.
            </p>
          </div>

          <nav className="grid grid-cols-2 gap-6 md:col-span-2">
            <div>
              <div className="font-semibold mb-2">Pagini</div>
              <ul className="space-y-2 text-sm">
                <li><Link to="/" className="hover:underline">Acasă</Link></li>
                <li><Link to="/servicii" className="hover:underline">Servicii</Link></li>
                <li><Link to="/portofoliu" className="hover:underline">Portofoliu</Link></li>
                <li><Link to="/despre" className="hover:underline">Despre</Link></li>
                <li><Link to="/contact" className="hover:underline">Contact</Link></li>
              </ul>
            </div>
            <div>
              <div className="font-semibold mb-2">Rochii</div>
              <ul className="space-y-2 text-sm">
                <li><Link to="/rochii/mireasa" className="hover:underline">Mireasă</Link></li>
                <li><Link to="/rochii/cununie-civila" className="hover:underline">Cununie civilă</Link></li>
                <li><Link to="/rochii/domnisoara-de-onoare" className="hover:underline">Domnișoară de onoare</Link></li>
                <li><Link to="/rochii/seara" className="hover:underline">Seară</Link></li>
                <li><Link to="/rochii/cocktail" className="hover:underline">Cocktail</Link></li>
                <li><Link to="/rochii/revelion" className="hover:underline">Revelion</Link></li>
              </ul>
            </div>
          </nav>

          <div>
            <div className="font-semibold mb-2">Contact</div>
            <ul className="space-y-2 text-sm">
              <li><a href="tel:+40763536451" className="hover:underline">+40 763 536 451</a></li>
              <li><a href="mailto:contact@tytystyle.ro" className="hover:underline">contact@tytystyle.ro</a></li>
              <li>Str. —</li>
              <li className="text-gray-500">L–V: —</li>
            </ul>
            <div className="flex gap-3 mt-3">
              {/* Use real, navigable URLs */}
              <a
                aria-label="Instagram"
                href="https://instagram.com/tytystyle"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg border hover:bg-gray-50"
              >
                <svg width="18" height="18" viewBox="0 0 24 24">
                  <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm5 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm6-.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" fill="currentColor"/>
                </svg>
              </a>
              <a
                aria-label="Facebook"
                href="https://facebook.com/tytystyle"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg border hover:bg-gray-50"
              >
                <svg width="18" height="18" viewBox="0 0 24 24">
                  <path d="M13 22v-8h3l1-4h-4V7.5c0-1.1.3-1.8 1.9-1.8H17V2.2C16.4 2.1 15.2 2 13.8 2 10.9 2 9 3.7 9 7v3H6v4h3v8h4z" fill="currentColor"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t text-xs text-gray-500 flex items-center justify-center">
          <span>© {new Date().getFullYear()} TytyStyle. Toate drepturile rezervate.</span>
        </div>
      </div>
    </footer>
  );
}
